import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { CreateInc, GetInc } from "../../../features/Emp/EmpSlice";
import dayjs from "dayjs";
import { Tooltip } from "@mui/material";
import axios from "axios";
import { base_url } from "../../../utils/AxiosConfig";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import { Plus } from "lucide-react";
import CloseIcon from "@mui/icons-material/Close";
import BusinessIcon from "@mui/icons-material/Business";

let alvnceschema = Yup.object().shape({
  CmpCode: Yup.string(),
  EmpId: Yup.string(),
  AllowanceType: Yup.string(),
  Amount: Yup.string(),
  ADate: Yup.string(),
  AffectOTCalc: Yup.string(),
});
const CreateIncrement = ({
  calculationInc,
  EmpIdTop,
  getIncrementList,
  onValuesChange,
}) => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const ref = useRef();
  const empStateInc = useSelector((state) => state?.emp.GetInc);
  const [emp, setEmp] = useState(null);

  // Increment
  const [incrementListFromAPI, setIncrementListFromAPI] = useState(null);
  const [increments, setIncrements] = useState(null);

  const dispatch = useDispatch();
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      increments: increments?.length
        ? increments.map((a) => ({
            CmpCode: companyCode,
            EmpId: EmpIdTop || "",
            AllowanceType: a.AllowanceType,
            Amount: a.Amount,
            ADate: a.ADate.split("T")[0],
            AffectOTCalc: a.AffectOTCalc,
          }))
        : [
            {
              CmpCode: companyCode,
              EmpId: EmpIdTop || "",
              AllowanceType: "",
              Amount: 0,
              ADate: new Date().toISOString().split("T")[0],
              AffectOTCalc: "",
            },
          ],
    },
    validationSchema: alvnceschema,
    onSubmit: (values, { resetForm }) => {
      console.log(values);
      setEmp(values.EmpId);

      // dispatch(CreateInc([values]));
      if (getIncrementList) {
        getIncrementList(EmpIdTop);
      }
      resetForm();
    },
  });



  useEffect(() => {
    getIncrementTypeList();
    getIncrement(EmpIdTop);
  }, []);

  useEffect(() => {
    dispatch(GetInc(emp));
  }, [emp]);

  useEffect(() => {
    let Incsum = empStateInc?.reduce((a, v) => (a = a + v.Amount), 0);
    // let AlvSum=AllowanceData?.reduce((a,v) =>  a = a + v.Amount , 0 )

    calculationInc(Incsum);
    // setAlvTotal(AlvSum)
  }, [empStateInc]);


    useEffect(() => {
      if (onValuesChange) {
        onValuesChange(formik.values);
      }
    }, [formik.values]);

  const isCreateDisabled =
    !EmpIdTop ||
    !formik.values.AllowanceType ||
    formik.values.Amount === "" ||
    !formik.values.ADate ||
    !formik.values.AffectOTCalc;

  // Increment
  const [showIncrementCreationEditPopup, setShowIncrementCreationEditPopup] =
    useState(false);

  // Increment
  const initialIncrementInAction = {
    increment_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7371", // dummy transaction id
    mode: "ENTRY",
  };

  // Increment
  const [incrementNameInInputBoxNew, setIncrementNameInInputBoxNew] = useState(
    initialIncrementInAction,
  );

  // Increment
  const initialIncrementInActionEdit = {
    increment_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  // Increment
  const [incrementNameInInputBoxEdit, setIncrementNameInInputBoxEdit] =
    useState(initialIncrementInActionEdit);

  // Increment
  const newIncrementAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/INCREMENT/${incrementNameInInputBoxNew.increment_name}/${initialIncrementInAction.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getIncrementTypeList();
        setIncrementNameInInputBoxNew(initialIncrementInAction);
      }, {})
      .catch((err) => {});
  };

  // Increment
  const editIncrementAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/EDIT/${companyCode}/INCREMENT/${incrementNameInInputBoxEdit.increment_name}/${incrementNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getIncrementTypeList();
        setIncrementNameInInputBoxEdit(initialIncrementInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const getIncrementTypeList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/INCREMENT/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setIncrementListFromAPI(newArray);
    } else {
      console.log("error");
    }
  };

  const getIncrement = async (emp) => {
    const response = await axios.get(
      `${base_url}/api/PersonalInfoIncrementList/${companyCode}/${emp}`,
    );
    console.log("getIncrements called1:", response);
    if (response.data) {
      console.log("getIncrements called:", response?.data);
      setIncrements(response.data);
    }
  };

  const onAddRow = () => {
    const newRow = {
      CmpCode: companyCode,
      EmpId: EmpIdTop || "",
      AllowanceType: "",
      Amount: 0,
      ADate: new Date().toISOString().split("T")[0],
      AffectOTCalc: "",
    };

    formik.setFieldValue("increments", [...formik.values.increments, newRow]);
  };

  const onDeleteRow = (index) => {
    const updated = formik.values.increments.filter((_, i) => i !== index);
    formik.setFieldValue("increments", updated);
  };

  return (
    <div className="alowance-data">
      <form action="" onSubmit={formik.handleSubmit}>
        <table className=" min-w-full bg-white rounded-sm border border-[gray-300] text-xs ">
          <thead>
            <tr className="bg-[#2663EB] text-white text-sm">
              <th className="px-2 py-1 border-none  font-semibold">
                Description
              </th>
              <th className="px-2 py-1 border-none font-semibold">Amount</th>
              <th className="px-2 py-1 border-none font-semibold">Date</th>
              <th className="px-2 py-1 border-none font-semibold">Reason</th>
              <th className="px-2 py-1 border-none font-semibold text-center">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {formik.values.increments.map((row, index) => (
              <tr key={index}>
                <td className=" border">
                  <div className="flex justify-between items-center gap-2 ">
                    <select
                      key={index}
                      name={`increments.${index}.AllowanceType`}
                      value={formik.values.increments[index].AllowanceType}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="
    w-full
    px-2 py-2
    text-sm
    border
    rounded
    outline-none
    focus:ring-0 focus:ring-blue-500
    focus:border-blue-500
  "
                    >
                      <option value="">Select Increment Type</option>
                      {incrementListFromAPI?.map((item, index) => (
                        <option key={index} value={item.Description}>
                          {item.Description}
                        </option>
                      ))}
                    </select>
                    <button
                      type="button"
                      onClick={() => setShowIncrementCreationEditPopup(true)}
                      className="bg-blue-500 hover:bg-blue-700 px-2 py-1 text-white font-semibold rounded-md mr-2"
                    >
                      Manage
                    </button>
                  </div>
                </td>
                <td className="border">
                  <input
                    type="text"
                    className="
    w-full
    px-3 py-2
    text-sm
    border-none
    outline-none
    focus:ring-2 focus:ring-blue-500
    focus:border-blue-500
  "
                    key={index}
                    name={`increments.${index}.Amount`}
                    value={formik.values.increments[index].Amount}
                    // onChange={formik.handleChange("Amount")}
                    // onBlur={formik.handleBlur("Amount")}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </td>
                <td className="border">
                  <input
                    type="date"
                    className="
    w-full
    px-3 py-2
    text-smƒ
    border-none
    outline-none
    focus:ring-2 focus:ring-blue-500
    focus:border-blue-500
  "
                    ref={ref}
                    key={index}
                    name={`increments.${index}.ADate`}
                    value={formik.values.increments[index].ADate}
                    placeholder="Date"
                    onFocus={() => (ref.current.type = "date")}
                    // onChange={formik.handleChange("ADate")}
                    // onBlur={formik.handleBlur("ADate")}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />{" "}
                </td>
                <td className="border">
                  <input
                    type="text"
                    className="
    w-full
    px-3 py-2
    text-sm
    border-none
    outline-none
    focus:ring-2 focus:ring-blue-500
    focus:border-blue-500
  "
                    key={index}
                    name={`increments.${index}.AffectOTCalc`}
                    value={formik.values.increments[index].AffectOTCalc}
                    // onChange={formik.handleChange("AffectOTCalc")}
                    // onBlur={formik.handleBlur("AffectOTCalc")}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </td>
                <td className="border">
                  {/* Add Row */}
                  <button
                    type="button"
                    onClick={onAddRow}
                    className="px-3 py-1.5 mr-2 text-xs font-semibold rounded-xl shadow-md bg-green-600 hover:bg-green-700 text-white"
                  >
                    Add Row
                  </button>

                  {/* Delete Row */}
                  {formik.values.increments.length > 1 && (
                    <button
                      type="button"
                      onClick={() => onDeleteRow(index)}
                      className="px-3 py-1.5 text-xs font-semibold rounded-xl shadow-md bg-red-500 hover:bg-red-600 text-white"
                    >
                      Delete Row
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

       
      </form>

      {showIncrementCreationEditPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          {/* Modal Card */}
          <div className="w-[95%] max-w-xl bg-white rounded-2xl shadow-2xl p-6 max-h-[60vh] overflow-y-auto scrollbar-none">
            {/* Header */}
            <div className="flex items-center justify-between border-b pb-3">
              <h2 className="text-lg font-semibold text-[#2663EB] flex items-center gap-2">
                <BusinessIcon className="text-[#2663EB]" />
                INCREMENT TYPE MANAGEMENT
              </h2>

              <button
                onClick={() => setShowIncrementCreationEditPopup(false)}
                className="p-2 rounded-full hover:bg-gray-100 transition"
              >
                <CloseIcon />
              </button>
            </div>

            {/* Add New INCREMENT */}
            <div className="mt-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
              <input
                value={incrementNameInInputBoxNew.increment_name}
                type="text"
                placeholder="Enter new Increment type here..."
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                onChange={(e) =>
                  setIncrementNameInInputBoxNew((prev) => ({
                    ...prev,
                    increment_name: e.target.value,
                  }))
                }
              />

              <button
                type="button"
                onClick={newIncrementAPI}
                className="
          inline-flex items-center gap-2
          bg-blue-500
          text-white
          w-1/2
          px-2 py-1
          text-sm font-semibold
          rounded-md
          shadow-lg
          hover:from-blue-700 hover:to-blue-600
          active:scale-95
          transition-all duration-200
          focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
        "
              >
                <Plus size={16} />
                Add Increment
              </button>
            </div>

            {/* Increment */}
            <div className="mt-6 space-y-3">
              {incrementListFromAPI?.map((item) => {
                const isEditing =
                  incrementNameInInputBoxEdit.transaction_id
                    ?.trim()
                    ?.toLowerCase() === item.TranId?.trim()?.toLowerCase();

                return (
                  <div
                    key={item.TranId}
                    className="border border-gray-200 rounded-xl px-2 py-1 hover:shadow-md transition"
                  >
                    {/* Row Header */}
                    <div className="flex items-center justify-between">
                      <span className="font-medium text-gray-700">
                        {item.Description}
                      </span>

                      <button
                        type="button"
                        onClick={() =>
                          setIncrementNameInInputBoxEdit({
                            increment_name: item.Description,
                            transaction_id: item.TranId,
                          })
                        }
                        className="p-2 rounded-md hover:bg-gray-100 transition"
                      >
                        <EditIcon fontSize="small" className="text-gray-600" />
                      </button>
                    </div>

                    {/* Edit Section */}
                    {isEditing && (
                      <div className="mt-4 flex flex-col sm:flex-row gap-3">
                        <input
                          type="text"
                          value={incrementNameInInputBoxEdit.increment_name}
                          onChange={(e) =>
                            setIncrementNameInInputBoxEdit((prev) => ({
                              ...prev,
                              increment_name: e.target.value,
                            }))
                          }
                          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                        />

                        <div className="flex gap-2">
                          <button
                            type="button"
                            onClick={() =>
                              setIncrementNameInInputBoxEdit(
                                initialIncrementInActionEdit,
                              )
                            }
                            className="flex items-center gap-1 px-3 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                          >
                            <CancelIcon fontSize="small" />
                            Cancel
                          </button>

                          <button
                            type="button"
                            onClick={editIncrementAPI}
                            className="flex items-center gap-1 bg-green-600 text-white px-3 py-2 rounded-lg hover:bg-green-700 transition"
                          >
                            <SaveIcon fontSize="small" />
                            Save
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateIncrement;
